// lib
import md5 from "md5";

// { a: 1, b: 2} => "a=1,b=2"
export const plainHash = (object) =>
  object &&
  Object.getOwnPropertyNames(object)
    .sort()
    .map((p) => [p, object[p]].join("="))
    .join(",");

const HASH_LENGTH = 32;
export const encodedHash = (object) => md5(JSON.stringify(object)).slice(0, HASH_LENGTH);
